module.exports = __webpack_public_path__ + "static/cercamappa_hinterland-b5265b3e402bf6a7995eb09e456e0984.jpg";